export default __webpack_public_path__ + "static/media/spin2.3e438016.png";